import { Client, Account } from 'appwrite';

const client = new Client();

client
  .setEndpoint(`${process.env.REACT_APP_WRITE_END_POINT}`)
  .setProject(`${process.env.REACT_APP_WRITE_PROJECT_ID}`);

export const account = new Account(client);

export default client;
